/* ==========================================================================
   Yummy Gummy — Password splash behaviour.
   1) Live countdown (runs always; degrades to hidden if no/invalid date).
   2) GSAP entrance (progressive enhancement; only when motion is enabled).
   Guarded so content is NEVER stuck hidden. The inline head script in
   layout/password.liquid runs a watchdog that reveals after a timeout.
   ========================================================================== */
(function () {
  'use strict';

  /* ---- 1. Countdown ---------------------------------------------------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initCountdown() {
    var el = document.querySelector('[data-countdown]');
    if (!el) return;

    var target = el.getAttribute('data-countdown');
    var end = target ? new Date(target).getTime() : NaN;
    if (!target || isNaN(end)) { el.style.display = 'none'; return; }

    var nums = {
      days: el.querySelector('[data-cd="days"]'),
      hours: el.querySelector('[data-cd="hours"]'),
      minutes: el.querySelector('[data-cd="minutes"]'),
      seconds: el.querySelector('[data-cd="seconds"]')
    };

    function set(d, h, m, s) {
      if (nums.days) nums.days.textContent = pad(d);
      if (nums.hours) nums.hours.textContent = pad(h);
      if (nums.minutes) nums.minutes.textContent = pad(m);
      if (nums.seconds) nums.seconds.textContent = pad(s);
    }

    var timer;
    function tick() {
      var diff = end - new Date().getTime();
      if (diff <= 0) {
        set(0, 0, 0, 0);
        el.setAttribute('data-ended', '');
        if (timer) clearInterval(timer);
        return;
      }
      // When there's no Days unit, Hours shows the TOTAL hours remaining.
      var days = Math.floor(diff / 86400000);
      var hours = nums.days
        ? Math.floor((diff % 86400000) / 3600000)
        : Math.floor(diff / 3600000);
      set(days, hours, Math.floor((diff % 3600000) / 60000), Math.floor((diff % 60000) / 1000));
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  /* ---- 2. Entrance ----------------------------------------------------- */
  var root = document.documentElement;

  function reveal() {
    window.__ygPwDone = true;
    root.classList.remove('yg-pw-animate');
  }

  function initEntrance() {
    // Motion disabled (reduced-motion or animations off) → nothing to do.
    if (!root.classList.contains('yg-pw-animate')) return;

    if (!window.gsap) { reveal(); return; }
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { reveal(); return; }

    var gsap = window.gsap;
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var items = document.querySelectorAll('[data-pw-reveal]');

    window.__ygPwDone = true;

    if (items.length) {
      gsap.set(items, { opacity: 0, y: isMobile ? 14 : 26 });
      gsap.to(items, {
        opacity: 1, y: 0,
        duration: isMobile ? 0.5 : 0.7,
        ease: 'power3.out',
        stagger: 0.07,
        delay: 0.05,
        clearProps: 'transform',
        onComplete: function () { root.classList.remove('yg-pw-animate'); }
      });
    } else {
      reveal();
    }

    if (!isMobile) {
      document.querySelectorAll('[data-pw-float]').forEach(function (g, i) {
        gsap.to(g, {
          y: '+=' + (8 + (i % 3) * 4),
          rotation: i % 2 ? 6 : -6,
          duration: 2.6 + (i % 4) * 0.4,
          ease: 'sine.inOut',
          repeat: -1, yoyo: true, delay: i * 0.2
        });
      });
    }
  }

  function start() { initCountdown(); initEntrance(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
